/** @format */
import angular from 'angular';
import { from } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { localizedStringFilterModule } from 'sis-common';
import { locationServiceModule } from '../service/location.service';
import { filterInput, TypeaheadComponent } from '../typeahead/typeahead.component';
import locationSearchTpl from './locationSearch.tpl.html';

export const locationSearchModule = 'sis-components.location.searchLocation';

(function () {
    LocationSearchController.$inject = ['$log', 'localizedStringFilter', 'locationService', 'universityService'];
    angular
        .module(locationSearchModule, [localizedStringFilterModule, locationServiceModule, TypeaheadComponent.downgrade.moduleName])
        .controller('locationSearchController', LocationSearchController)
        .directive('locationSearch', locationSearchDirective);

    function locationSearchDirective() {
        return {
            restrict: 'E',
            scope: {
                onSelect: '&',
                location: '=?',
            },
            controller: 'locationSearchController as ctrl',
            bindToController: true,
            template: locationSearchTpl,
        };
    }

    function LocationSearchController($log, localizedStringFilter, locationService, universityService) {
        const ctrl = this;

        ctrl.selectItem = function (selectedLocation) {
            if (angular.isDefined(ctrl.onSelect)) {
                ctrl.onSelect({ location: selectedLocation });
            }
        };

        ctrl.searchLocations = function (textQuery$) {
            return textQuery$.pipe(
                filterInput(2),
                switchMap(textQuery => from(locationService.searchByString(textQuery, universityService.getCurrentUniversityOrgId()))),
                map(result => result.searchResults),
            );
        };

        ctrl.renderLocation = location => localizedStringFilter(location.name);
    }
})();
